import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { QueryConfig } from '@/lib/react-query';
import { TenantListResponse } from '@/types/tenant';

export const getTenants = (): Promise<TenantListResponse> => {
  console.info('get-tenant-list.ts_1');
  return api.get('/tenant/select', { params: {} });
};

export const getTenantsQueryOptions = () => {
  console.info('get-tenant-list.ts_2');
  return {
    queryKey: ['tenants'],
    queryFn: () => getTenants(),
  };
};

type UseGetTenantsOptions = {
  queryConfig?: QueryConfig<typeof getTenantsQueryOptions>;
};

export const useGetTenants = ({ queryConfig }: UseGetTenantsOptions) => {
  console.info('get-tenant-list.ts_3');
  return useQuery({
    ...getTenantsQueryOptions(),
    ...queryConfig,
  });
};
